export const marketplaceEn = {
  marketplace: {
    title: "Marketplace",
    subtitle: "Buy and sell agricultural products",
    products: "Products",
    services: "Services",
    myListings: "My Listings",
    orders: "Orders",
    addListing: "Add Listing",
    searchProducts: "Search products...",
    categories: "Categories",
    seeds: "Seeds",
    fertilizers: "Fertilizers",
    pesticides: "Pesticides",
    equipment: "Equipment",
    price: "Price",
    quantity: "Quantity",
    addToCart: "Add to Cart",
    buyNow: "Buy Now",
    contactSeller: "Contact Seller"
  },
  productMarketplace: {
    title: "Product Marketplace",
    subtitle: "Buy and sell agricultural products directly with producers, exporters, and wholesalers",
    activeListings: "Active Listings",
    verifiedProducers: "Verified Producers",
    transactionsThisMonth: "Transactions This Month",
    avgDeliveryTime: "Avg Delivery Time",
    searchPlaceholder: "Search products, producers, regions...",
    listProduct: "List Product",
    tabs: {
      browse: "Browse",
      sell: "Sell",
      orders: "Orders",
      analytics: "Analytics"
    },
    categories: {
      cereals: "Cereals & Grains",
      fruits: "Fruits",
      vegetables: "Vegetables",
      oils: "Oils & Fats"
    },
    products: "products",
    featuredProducts: "Featured Products",
    featuredDesc: "Top-rated products from verified producers",
    contact: "Contact",
    producers: "Producers",
    producersDesc: "Sell your harvest directly to buyers and get better prices for your production.",
    registerAsProducer: "Register as Producer",
    exporters: "Exporters",
    exportersDesc: "Connect with international markets and expand your reach globally.",
    connectWithExporters: "Connect with Exporters",
    wholesalers: "Wholesalers",
    wholesalersDesc: "Find bulk buyers for your production with competitive pricing.",
    findWholesalers: "Find Wholesalers",
    listYourProducts: "List Your Products",
    listDesc: "Create listings to sell your agricultural products",
    startSelling: "Start selling your products to a network of verified buyers",
    createListing: "Create Listing",
    yourOrders: "Your Orders",
    noOrders: "No orders yet. Start buying or selling to see your orders here.",
    salesAnalytics: "Sales Analytics",
    analyticsComingSoon: "Analytics dashboard coming soon. Track your sales performance here."
  },
  prefinancing: {
    title: "Prefinancing & Factoring",
    subtitle: "Access financing solutions with our trusted financial partners",
    calculateFinancing: "Calculate Financing",
    stats: {
      totalFunded: "Total Funded",
      activeFarmers: "Active Farmers",
      avgApprovalTime: "Avg Approval Time",
      successRate: "Success Rate"
    },
    tabs: {
      options: "Options",
      partners: "Partners",
      apply: "Apply",
      myFinancing: "My Financing"
    },
    options: {
      prefinancing: {
        title: "Pre-Harvest Financing",
        description: "Get capital before your harvest to cover operational costs",
        features: [
          "Finance up to 70% of expected harvest value",
          "Flexible repayment after harvest",
          "No collateral required for verified farms"
        ]
      },
      factoring: {
        title: "Invoice Factoring",
        description: "Convert your invoices into immediate cash flow",
        features: [
          "Receive up to 90% of invoice value immediately",
          "Non-recourse factoring available",
          "Fast approval in 24-48 hours"
        ]
      }
    },
    interestRate: "Interest Rate",
    term: "Term",
    learnMore: "Learn More",
    howItWorks: "How It Works",
    howItWorksDesc: "Simple steps to access agricultural financing",
    steps: {
      step1: { title: "Submit Application", description: "Complete your profile and financing request" },
      step2: { title: "Document Review", description: "Our partners verify your farm data" },
      step3: { title: "Approval", description: "Receive financing terms within 48h" },
      step4: { title: "Receive Funds", description: "Money transferred to your account" }
    },
    ourPartners: "Our Financial Partners",
    partnersDesc: "Trusted institutions specializing in agricultural financing",
    partners: {
      specialty: {
        prefinancing: "Harvest Pre-Financing",
        agricultural: "Agricultural Loans",
        factoring: "Invoice Factoring",
        sustainable: "Sustainable Agriculture"
      }
    },
    funded: "Funded",
    viewDetails: "View Details",
    applyForFinancing: "Apply for Financing",
    applyDesc: "Complete the application to get personalized financing offers",
    applicationForm: "Complete our simple application form to get started",
    startApplication: "Start Application",
    useCalculator: "Use Calculator",
    benefits: {
      secure: { title: "Secure Process", description: "Bank-level encryption and verified partners" },
      competitive: { title: "Competitive Rates", description: "Best rates negotiated with multiple partners" },
      fast: { title: "Fast Approval", description: "Get approved within 48 hours" }
    },
    myActiveFinancing: "My Active Financing",
    noActiveFinancing: "No active financing. Apply for financing to grow your operation.",
    applyNow: "Apply Now"
  }
};
